// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-8e104436] .modal-backdrop{background-color:rgba(0,0,0,.4)!important}[data-v-8e104436] .modal-fullscreen .modal-dialog{max-width:100%!important;margin:0!important;top:0!important;bottom:0!important;left:0!important;right:0!important;height:100%!important;display:flex!important;position:fixed!important}", ""]);
// Exports
module.exports = exports;
